import React, { useEffect, useState } from 'react'
// import Swiper core and required modules
import SwiperCore, {
    Autoplay,
    Mousewheel,
    Navigation,
    Pagination,
    Scrollbar,
    A11y,
    Keyboard,
} from 'swiper'

import { Swiper, SwiperSlide } from 'swiper/react'
// Import Swiper styles
import 'swiper/scss'
import 'swiper/scss/navigation'
import 'swiper/scss/pagination'
import 'swiper/scss/scrollbar'

const SwiperRender = ({ options, onPress, updateSlide }) => {
    const [swiperElement, setSwiper] = useState({
        params: {
            breakpoints: {},
            rebuildOnUpdate: true,
            tag: 'div',
            className: '',
            allowTouchMove: true,
            autoHeight: false,
            autoplay: false,
            direction: 'horizontal',
            followFinger: true,
            grabCursor: true,
            longSwipes: true,
            slidesPerView: 4,
            spaceBetween: 0,
            initialSlide: 0,
            loop: false,
            navigation: false,
            mousewheel: false,
            keyboard: false,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            slideToClickedSlide: false,
            scrollbar: false,
            onSlideChange: false,
            wrapperTag: 'div',
            slideTag: 'div',
        },
        slides: [],
    })
    SwiperCore.use([
        Autoplay,
        Mousewheel,
        Navigation,
        Pagination,
        Scrollbar,
        A11y,
        Keyboard,
    ])

    useEffect(() => {
        // const use = [
        //     A11y,
        //     Pagination,
        //     Lazy,
        // ]
        // options.autoplay && use.push(Autoplay)
        // options.navigation && use.push(Navigation)
        // options.mousewheel && use.push(Mousewheel)
        // options.keyboard && use.push(Keyboard)
        // options.scrollbar && use.push(Scrollbar)
        // // install Swiper modules
        // SwiperCore.use(use)

        const params = { ...swiperElement.params }

        params.allowTouchMove = options.allowTouchMove || params.allowTouchMove
        params.autoHeight = options.autoHeight || params.autoHeight
        params.autoplay = options.autoplay || params.autoplay
        params.breakpoints = options.breakpoints || params.breakpoints
        params.className = options.className || params.className
        params.direction = options.direction || params.direction
        params.followFinger = options.followFinger || params.followFinger
        params.grabCursor = options.grabCursor || params.grabCursor
        params.initialSlide = options.initialSlide || params.initialSlide
        params.keyboard = options.keyboard || params.keyboard
        params.longSwipes = options.longSwipes || params.longSwipes
        params.loop = options.loop || params.loop
        params.mousewheel = options.mousewheel || params.mousewheel
        params.navigation = options.navigation || params.navigation
        params.onSlideChange = options.onSlideChange || false
        params.scrollbar = options.scrollbar || params.scrollbar
        params.slidesOffsetAfter =
            options.slidesOffsetAfter || params.slidesOffsetAfter
        params.slidesOffsetBefore =
            options.slidesOffsetBefore || params.slidesOffsetBefore
        params.slidesPerView = options.slidesPerView || params.slidesPerView
        params.slideToClickedSlide =
            options.slideToClickedSlide || params.slideToClickedSlide
        params.spaceBetween = options.spaceBetween || params.spaceBetween
        params.style = options.style || {}
        params.tag = options.tag || params.tag
        params.navigationMarkup = options.navigationMarkup || null
        params.wrapperTag = options.wrapperTag || params.wrapperTag

        const swiperItems = options.slides.map((slide, key) => {
            return (
                <SwiperSlide
                    key={`${slide.key}-swiper`}
                    tag={options.slideTag || params.slideTag}
                >
                    {slide}
                </SwiperSlide>
            )
        })

        setSwiper({ params, slides: swiperItems })
    }, [options])

    return (
        <>
            {swiperElement.slides.length ? (
                <Swiper
                    allowTouchMove={swiperElement.params.allowTouchMove}
                    autoHeight={swiperElement.params.autoHeight}
                    autoplay={swiperElement.params.autoplay}
                    breakpoints={swiperElement.params.breakpoints}
                    className={swiperElement.params.className}
                    direction={swiperElement.params.direction}
                    followFinger={swiperElement.params.followFinger}
                    grabCursor={swiperElement.params.grabCursor}
                    initialSlide={swiperElement.params.initialSlide}
                    keyboard={swiperElement.params.keyboard}
                    longSwipes={swiperElement.params.longSwipes}
                    loop={swiperElement.params.loop}
                    mousewheel={swiperElement.params.mousewheel}
                    navigation={swiperElement.params.navigation}
                    onSlideChange={(swiper) => {
                        if (
                            swiperElement.params.onSlideChange &&
                            typeof onPress === 'function'
                        ) {
                            onPress(swiper.realIndex)
                        }
                        if (
                            swiperElement.params.onSlideChange &&
                            typeof updateSlide === 'function'
                        ) {
                            updateSlide(swiper.realIndex + 1)
                        }
                    }}
                    scrollbar={swiperElement.params.scrollbar}
                    slidesOffsetAfter={swiperElement.params.slidesOffsetAfter}
                    slidesOffsetBefore={swiperElement.params.slidesOffsetBefore}
                    slideToClickedSlide={
                        swiperElement.params.slideToClickedSlide
                    }
                    slidesPerView={swiperElement.params.slidesPerView}
                    style={swiperElement.params.style}
                    spaceBetween={swiperElement.params.spaceBetween}
                    tag={swiperElement.params.tag}
                    wrapperTag={swiperElement.params.wrapperTag}
                >
                    {swiperElement.slides}
                    {swiperElement.params.navigationMarkup}
                </Swiper>
            ) : null}
        </>
    )
}

export default SwiperRender
